export default "__VITE_ASSET__BXwbcuBt__"